import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import HomePage2 from "../views/HomePage2";
import IntroPage from "../views/IntroPage";
import TermsPage from "../views/TermsPage";
import SearchPage2 from "../views/SearchPage/SearchPage2";
import { ProductDetailPage } from "../views/SearchPage/ProductDetailPage";
import ProductDetailPopupPage from "../views/SearchPage/ProductDetailPopupPage";
import MyPage from "../views/MyPage";
import StatisticsPage from "../views/StatisticsPage";
import LoginPage from "../auth/LoginPage";
import ErrorPage from "../views/errors/ErrorPage";
import AuthGuard from "../auth/AuthGuard";
import { ArticleList, FaqViews, QnaList, ArticleView, QnaView } from "../views/boards";
import { Manage4Member, Manage4Board, Manage4Article, Manage4Reply } from "../views/management";
import EvaluationResults, { EvaluationLoad } from "../components/assessment/EvaluationResults";


export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: <HomePage2 />,
      },
      {
        path: "intro",
        element: <IntroPage />,
      },
      {
        path: "search",
        element: <SearchPage2 />,
      },
      {
        path: "detail/:coffee_key_id",
        element: <ProductDetailPage />,
      },
      {
        path: "mypage",
        element: (
          <AuthGuard>
            <MyPage />
          </AuthGuard>
        ),
      },
      {
        path: "statistics",
        element: <StatisticsPage />,
      },
      {
        path: "board",
        element: <ArticleList />,
      },
      {
        path: "boardview/:manageid/:boardid",
        element: <ArticleView />,
      },
      {
        path: "faq",
        element: <FaqViews />,
      },
      {
        path: "qna",
        element: <QnaList />,
      },
      {
        path: "qnaview/:manageid/:boardid",
        element: <QnaView />,
      },
      {
        path: "manage4member",
        element: <Manage4Member />,
      },
      {
        path: "manage4board",
        element: <Manage4Board />,
      },
      {
        path: "manage4article",
        element: <Manage4Article />,
      },
      {
        path: "manage4reply",
        element: <Manage4Reply />,
      },
      {
        path: "addon/:coffee_key_id",
        element: <EvaluationLoad />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
    ],
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "popupdetail/:coffee_key_id",
    element: <ProductDetailPopupPage />,
  },
  {
    path: "popupaddon/:coffee_key_id",
    element: <EvaluationLoad />,
  },
]);
